export enum ActionType {
  GET_PROFILE = 'GET_PROFILE',
  SET_PROFILE = 'SET_PROFILE',
}

export interface IProfile {
  id: number
  email: string
  pendingEmail?: string | null
  firstName: string
  lastName: string
  mobilePhone: string
  title: string
  avatar: string
}
